import script from "./UserDetailModal.vue?vue&type=script&setup=true&lang=js"
export * from "./UserDetailModal.vue?vue&type=script&setup=true&lang=js"

import "./UserDetailModal.vue?vue&type=style&index=0&id=d4119d12&scoped=true&lang=css"

import exportComponent from "../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.4.35_vue@3.4.35_webpack@5.93.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d4119d12"]])

export default __exports__